import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
    Paper,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
} from "@material-ui/core";
import { noImg } from "vrcore-dashboard/dist/utilities";
import styled from "styled-components";
import { Link } from "react-router-dom";

const RegNumTypography = styled(Typography)`
    margin-right: 25% !important;
    margin-left: 25% !important;
    margin-bottom: 10px !important;
`;

const ViewQualificationInfoModal = (props) => {
    const [modalState, setModalState] = useState(props.modalState);
    const [qualification, setQualification] = useState(
        props.selectedQualification
    );
    const [selectedPhotoModal, setSelectedPhotoModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState("");
    useEffect(() => {
        setModalState(props.modalState);
        setQualification(props.selectedQualification);
    }, [props.modalState, props.selectedQualification]);
    return (
        
        <>
            <Modal isOpen={modalState}>
                {qualification && (
                    <Paper style={{ width: "max-content" }}>
                        {" "}
                        <ModalHeader>Qualification Images</ModalHeader>
                        <div style={{ display: "flex" }}>
                            <img
                                style={{
                                    width: "350px",
                                    height: "350px",
                                    margin: "10px",
                                    border: "1px solid black",
                                    borderRadius: "5px",
                                }}
                                src={
                                    qualification.qualification_img === "" ||
                                    qualification.qualification_img === "N/A"
                                        ? noImg
                                        : qualification.qualification_img
                                }
                                onClick={() => {
                                    setSelectedPhotoModal(true);
                                    setSelectedPhoto(
                                        qualification.qualification_img
                                    );
                                }}
                                alt="Qualification Expiry Date Img1"
                            />
                            <img
                                style={{
                                    width: "350px",
                                    height: "350px",
                                    margin: "10px",
                                    border: "1px solid black",
                                    borderRadius: "5px",
                                }}
                                src={
                                    qualification.qualification_img_2 === "" ||
                                    qualification.qualification_img_2 ===
                                        "N/A" ||
                                    qualification.qualification_img_2 ===
                                        undefined
                                        ? noImg
                                        : qualification.qualification_img_2
                                }
                                onClick={() => {
                                    setSelectedPhotoModal(true);
                                    setSelectedPhoto(
                                        qualification.qualification_img_2
                                    );
                                }}
                                alt="Qualification Expiry Date Img2"
                            />
                        </div>
                        <RegNumTypography variant="title">
                            Registration Number:
                            {qualification.qualification_reg_num === ""
                                ? "Required But Not Selected"
                                : qualification.qualification_reg_num === "N/A"
                                ? "Not Required"
                                : qualification.qualification_reg_num}
                        </RegNumTypography>
                        <p
                            style={{
                                textAlign: "center",
                                backgroundColor: "#c7c7cc",
                                paddingTop: "4px",
                                paddingBottom: "4px",
                                fontWeight: "bold",
                            }}
                        >
                            Attached Files
                        </p>
                        {qualification.attached_files && (
                            <List>
                                {qualification.attached_files.map((e) => {
                                    return (
                                        <Link
                                            to={`/pdf-viewer/file_manager/${e.file_type}/${e.file_id}`}
                                        >
                                            <ListItem
                                                style={{ textAlign: "center" }}
                                            >
                                                <ListItemText
                                                    primary={e.file}
                                                />
                                            </ListItem>
                                        </Link>
                                    );
                                })}
                            </List>
                        )}
                        <ModalFooter>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    props.setModalState(false);
                                    props.setSelectedQualification(false);
                                }}
                            >
                                Close
                            </Button>
                            <Button
                                disabled={props.canUpdate === false}
                                style={{
                                    marginLeft: "25px",
                                    background: "#0188cc",
                                    color: "white",
                                }}
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                    props.setEditQualificationModalState(true);
                                    props.setModalState(false);
                                }}
                            >
                                Edit
                            </Button>
                        </ModalFooter>
                    </Paper>
                )}
            </Modal>
            <Modal isOpen={selectedPhotoModal}>
                <ModalHeader>Qualification Image</ModalHeader>
                <ModalBody>
                    <img
                        src={selectedPhoto}
                        alt="Site"
                        style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: 10,
                        }}
                    />
                </ModalBody>
                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                setSelectedPhotoModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default ViewQualificationInfoModal;
